/*
 * Copyright 2022-present terrestris GmbH & Co. KG
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 */
import React, { useEffect, useState } from 'react';

import {
  faLocationCrosshairs
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';

import OlPoint from 'ol/geom/Point';

import { SimpleButton } from '@terrestris/react-geo';
import { useGeoLocation, useMap } from '@terrestris/react-util';

import './ProjectGeoLocationButton.less';

export const ProjectGeoLocationButton: React.FC = (): React.JSX.Element => {
  const map = useMap();
  const [active, setActive] = useState(false);
  const [geolocation, setGeolocation] = useState<any | null>(null);

  if (!map) {
    return <></>;
  }

  const toggle = () => {
    setActive((prev) => !prev);
  };

  useEffect(() => {
    if (active && geolocation?.position) {
      map.getView().fit(
        new OlPoint(geolocation.position),
        {
          maxZoom: 6,
          duration: 1000
        }
      );
    }
  }, [active, geolocation, map]);

  useGeoLocation({
    active,
    enableTracking: true,
    showMarker: true,
    onGeoLocationChange: setGeolocation
  });

  return (
    <SimpleButton
      className={`geolocation-button ${active ? 'pressed' : ''}`}
      tooltip={`Eigene Positionsanzeige ${active ? 'deaktivieren' : 'aktivieren'}`}
      tooltipProps={{
        mouseEnterDelay: .1,
        placement: 'right'
      }}
      aria-label="geolocation-button"
      onClick={toggle}
      icon={
        <FontAwesomeIcon
          icon={faLocationCrosshairs}
        />
      }
    />
  );
};

export default ProjectGeoLocationButton;
